import React from 'react';
import Main3DManager from '../components/3d/main.3d.manager';
import { WebGLContextType } from './context.types';

type Props = {
    children: React.ReactNode
}

export const WebGLContext = React.createContext<WebGLContextType | null>(null);
 
export const WebGLContextProvider = ({children}: Props) => {
    const [main3DManager, setMain3DManager] = React.useState<Main3DManager | undefined>(undefined);
    const [data, setData] = React.useState<any>(null);

    return (<WebGLContext.Provider
        value={{
            main3DManager,
            data,
            setData,
            setMain3DManager
        }}
    >
        {children}
    </WebGLContext.Provider>)
}